import React from 'react';
import useFetch from 'use-http';
import Button from 'components/UI/Button';
import FileDownload from 'assets/img/svg/download.svg';
import { TableFilter } from 'components/UI/Table';
import { buildQueryParams } from './tableUtils';

interface ExcelExportButtonProps {
	filter: TableFilter;
	endpoint: string;
	filename: string;
	additionalParams?: string;
}

export const ExcelExportButton: React.FC<ExcelExportButtonProps> = ({
	filter,
	endpoint,
	filename,
	additionalParams = '',
}) => {
	const { get: getXLSX } = useFetch({ responseType: 'blob' });

	const handleExport = () => {
		const params = buildQueryParams(filter);
		const additionalQuery = additionalParams ? `&${additionalParams}` : '';
		const fullUrl = `${endpoint}?${params}${additionalQuery}`;

		getXLSX(fullUrl)
			.then(response => {
				const url = window.URL.createObjectURL(response);
				const a = document.createElement('a');
				a.href = url;
				a.download = filename;
				document.body.appendChild(a);
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url);
			})
			.catch(error => {
				console.error(error);
			});
	};

	return (
		<Button
			onClick={handleExport}
			variant="secondary"
			size="sm"
			endIcon={
				<i>
					<img
						src={FileDownload}
						style={{
							filter: 'invert(22%) sepia(37%) saturate(900%) hue-rotate(193deg) brightness(90%) contrast(83%)',
						}}
					/>
				</i>
			}
		>
			Скачать xls
		</Button>
	);
};
